import { hpxTokens } from './hpxTokens'

export interface SignupTheme {
  bgMain: string
  checkoutDisabledBg: string
  secondaryText: string
  secondaryBorder: string
  royalBlue3: string
  royalBlue7: string
  dividerColor: string
  subtitleColor: string
  cardBg: string
  cardSurface: string
  primaryAccentFg: string
  overlayBg: string
  overlayBgStrong: string
  errorIconColor: string
}

export const hpxLightTheme: SignupTheme = {
  bgMain: hpxTokens.background,
  checkoutDisabledBg: '#edeefe',
  secondaryText: hpxTokens.secondaryText,
  secondaryBorder: hpxTokens.secondaryBorder,
  royalBlue3: hpxTokens.royalBlue3,
  royalBlue7: hpxTokens.royalBlue7,
  dividerColor: '#d1d2e4',
  subtitleColor: '#525365',
  cardBg: hpxTokens.royalBlue0,
  cardSurface: '#ffffff',
  primaryAccentFg: '#fdfdff',
  overlayBg: 'rgba(130, 131, 152, 0.1)',
  overlayBgStrong: 'rgba(130, 131, 152, 0.2)',
  errorIconColor: '#FF2A3F'
}

export const hpxDarkTheme: SignupTheme = {
  bgMain: hpxTokens.secondaryText,
  checkoutDisabledBg: hpxTokens.royalBlue10,
  secondaryText: hpxTokens.background,
  secondaryBorder: hpxTokens.secondaryBorder,
  royalBlue3: hpxTokens.royalBlue11,
  royalBlue7: hpxTokens.royalBlue5,
  dividerColor: hpxTokens.royalBlue11,
  subtitleColor: hpxTokens.royalBlue4,
  cardBg: hpxTokens.royalBlue12,
  cardSurface: hpxTokens.royalBlue11,
  primaryAccentFg: hpxTokens.secondaryText,
  overlayBg: 'rgba(196, 202, 255, 0.1)',
  overlayBgStrong: 'rgba(196, 202, 255, 0.2)',
  errorIconColor: '#FF2A3F'
}
